import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { getOptions } from '../components/options/strom';
import { data } from '../components/data/strom';
import { ist } from '../components/objects/strom';
import { Loader } from '../components/solar/Loader';
import { StatCard, StatCardSkeleton } from '../components/solar/StatCard';
import { ChartCardSkeleton } from '../components/solar/ChartCardSkeleton';
import { Bar } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';


class StromverbrauchClass extends Component {
    componentDidMount() {
        // This method runs when the component is first added to the page
        for (var k in ist) {
            this.props.request(ist[k]);
        }
    }

    render() {
        return (
            <div>
                <h3>Stromverbrauch</h3>
                {renderKPIRow(this.props)}
                {renderUIGesamt(this.props)}
            </div>
        );
    }
}

/**
 * KPI-Zeile: Gesamtbezug, Eigenverbrauch, Selbstversorgungsquote, aktuelles Jahr
 * als StatCards über dem Chart.
 */
function renderKPIRow(props) {
    const uiData = props.MixedBarDiagrammStromverbrauchUI || {};
    // BOTH isLoaded=true UND Daten vorhanden — nicht nur auf die Flag verlassen!
    let hasData = typeof (uiData.Soll) !== 'undefined' && uiData.Soll.length > 0;

    if (!props.isLoaded || !hasData) {
        return (
            <div className="stat-cards-row">
                <StatCardSkeleton />
                <StatCardSkeleton variant="energy" />
                <StatCardSkeleton variant="progress" />
                <StatCardSkeleton />
            </div>
        );
    }


    let gesamtBezug = 0;
    let gesamtEigenverbrauch = 0;

    const sollData = uiData.Soll || [];
    const istData = uiData.Ist || [];
    const yearLabels = uiData.Year || [];

    for (let i = 0; i < sollData.length; i++) {
        gesamtBezug += Number(sollData[i]) || 0;
    }
    for (let i = 0; i < istData.length; i++) {
        gesamtEigenverbrauch += Number(istData[i]) || 0;
    }

    // Selbstversorgungsquote = Eigenverbrauch / (Bezug + Eigenverbrauch) * 100
    const gesamtVerbrauch = gesamtBezug + gesamtEigenverbrauch;
    const selbstVersorgungsQuote = gesamtVerbrauch > 0
        ? Math.round((gesamtEigenverbrauch / gesamtVerbrauch) * 100)
        : 0;

    // Rekordjahr: höchster Gesamtverbrauch (Bezug + Eigenverbrauch)
    let rekordJahr = '-';
    let rekordKwh = 0;
    if (sollData.length > 0 && yearLabels.length > 0) {
        for (let i = 0; i < sollData.length; i++) {
            const jaehrlicherVerbrauch = (Number(sollData[i]) || 0) + (Number(istData[i]) || 0);
            if (jaehrlicherVerbrauch > rekordKwh) {
                rekordKwh = jaehrlicherVerbrauch;
                rekordJahr = yearLabels[i] || '-';
            }
        }
    }

    return (
        <div className="stat-cards-row">
            <StatCard
                value={Math.round(gesamtBezug)}
                label="Gesamtbezug"
                unit=" kWh"
                icon={<i className="bi bi-lightning" />}
                subLabel={Math.round(gesamtBezug).toLocaleString('de-DE') + ' kWh Netzbezug'}
                description="Strommenge die aus dem öffentlichen Netz bezogen wurde. Entsteht wenn die PV-Anlage nicht genug Strom liefert."
            />
            <StatCard
                value={Math.round(gesamtEigenverbrauch)}
                label="Eigenverbrauch"
                unit=" kWh"
                icon={<i className="bi bi-sun" />}
                variant="energy"
                subLabel={Math.round(gesamtEigenverbrauch).toLocaleString('de-DE') + ' kWh solar'}
                description="PV-Strom der direkt vor Ort verbraucht wurde. Höhere Werte bedeuten weniger Netzbezug."
            />
            <StatCard
                value={selbstVersorgungsQuote}
                label="Selbstversorgung"
                unit=" %"
                icon={<i className="bi bi-graph-up-arrow" />}
                variant={selbstVersorgungsQuote >= 50 ? 'energy' : selbstVersorgungsQuote >= 25 ? 'progress' : 'consumption'}
                subLabel={selbstVersorgungsQuote + '% des Verbrauchs deckt PV'}
                description="Anteil des Strombedarfs der durch die eigene PV-Anlage gedeckt wird. Rest stammt aus dem Netz."
            />
            <StatCard
                value={Math.round(rekordKwh)}
                label={"Rekordjahr " + rekordJahr}
                unit=" kWh"
                icon={<i className="bi bi-trophy" />}
                subLabel={rekordJahr !== '-' ? Math.round(rekordKwh).toLocaleString('de-DE') + ' kWh Gesamtwert' : '-'}
                description="Bester bisheriger Gesamtertrag aller Jahre. Zeigt die maximale Leistungsfähigkeit der Anlage."
            />
        </div>
    );
}

function renderUIGesamt(props) {
    let MixedBarDiagrammStromverbrauchUI = props.MixedBarDiagrammStromverbrauchUI || {}
    let hasData = typeof (MixedBarDiagrammStromverbrauchUI.Soll) !== 'undefined';

    // Show skeleton while loading or no real data yet
    if (!props.isLoaded || !hasData) {
        return <ChartCardSkeleton />;
    }

    var einnahmen = 0;
    var ausgaben = 0;

    for (let i = 0; i < MixedBarDiagrammStromverbrauchUI.Soll.length; i++) {
        ausgaben += MixedBarDiagrammStromverbrauchUI.Soll[i];
    }
    for (let i = 0; i < MixedBarDiagrammStromverbrauchUI.Ist.length; i++) {
        einnahmen += MixedBarDiagrammStromverbrauchUI.Ist[i];
    }

    let chartData = {
        labels: MixedBarDiagrammStromverbrauchUI.Year,
        datasets: [
            { ...data.datasets[0], label: data.datasets[0].label + " (" + ausgaben + " kwh)", data: MixedBarDiagrammStromverbrauchUI.Soll },
            { ...data.datasets[1], label: data.datasets[1].label + " (" + Math.round((einnahmen) * 100) / 100 + " kwh)", data: MixedBarDiagrammStromverbrauchUI.Ist }
        ]
    };

    return (
        <Card className="chart-card">
            <Card.Body>
                <Bar data={chartData} options={{ ...getOptions(), animation: false }} />
            </Card.Body>
        </Card>
    );
}

export default connect(
    state => state.stromReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(StromverbrauchClass);
